const randomString = length => {
  return Array.from(Array(length), () => Math.floor(Math.random() * 36).toString(36)).join('');
}

const moneyFormat = (num) => {
  return `${ (num).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }`;
}

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

class BundleTemplate extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    if (!this.form) return;

    this.data = this.form.nextElementSibling ? JSON.parse(this.form.nextElementSibling.textContent) : null;
    if (!this.data) return;

    console.log(this.data);

    this.submitBtn = this.form.querySelector('button[type="submit"]');
    this.errorEl = this.form.elements['error-handler'];

    this.selectors = this.form.querySelectorAll('[name="grid product bundle variant"]');
    this.selectors.forEach((selector) => {
      selector.addEventListener('change', (e) => this.validateSelectors());
    });
    this.validateSelectors();

    this.form.addEventListener('submit', async (e) => {
      e.preventDefault();
      this.validateForm();
    });
  }

  validateSelectors() {
    this.submitBtn.setAttribute('disabled', true);

    const unselected = [...this.selectors].filter((el) => el.value === null || el.value === 'undefined' || el.value === '');
    if (unselected.length === 0) {
      this.submitBtn.textContent = "Add bundle to cart";
      this.submitBtn.removeAttribute('disabled');
      return;
    }

    this.submitBtn.textContent = `Please select (${unselected.length}) option${unselected.length > 1 ? 's' : ''}`;
  }

  validateForm() {
    const {
      id,
      title,
      handle,
      tags,
      featured_image,
      price: bundlePrice,
      compare_at_price: bundleCompareAtPrice
    } = this.data.parent;

    const totalVariantsSum = [...this.selectors].reduce((acc, el) => {
      if (el.tagName === 'INPUT') {
        return acc + +el.dataset.price
      }
      return acc + +el.options[el.selectedIndex].dataset.price
    }, 0);

    const variants = [...this.selectors].reduce((acc, el, index, array) => {
      const firstInstanceIndex = array.findIndex(a => a.value === el.value);

      if (index !== firstInstanceIndex) return acc;
      return [...acc, el.value];
    }, []);

    const uniqueId = randomString(6);
    const rate =
      bundleCompareAtPrice && bundleCompareAtPrice > bundlePrice ?
        bundlePrice / bundleCompareAtPrice :
        bundlePrice / totalVariantsSum;
    let temp = 0;

    const items = [...this.selectors].reduce((acc, el, index, arr) => {
      const price = el.tagName === 'INPUT' ? el.dataset.price : el.options[el.selectedIndex].dataset.price;
      let discountedValue = Math.round(price * rate);

      if (el === arr.at(-1)) {
        const diff = bundlePrice - temp;
        if (diff !== discountedValue)
          discountedValue = diff
      }
      temp += discountedValue;

      const props = {
        "_bundle": `${handle}|${id}`,
        "_bundleUniqueID": uniqueId,
        "_bundleName": title,
        "_bundleImage": featured_image,
        "_bundlePrice": bundlePrice,
        "_bundleVariants": variants.join('|'),
        "_bundleVariantItem": el.dataset.title,
        "_bundleTags": tags.toString(),
        "_originalVariantSinglePrice": price,
        "_rate": rate,
        "_newFixedPrice": Math.abs(discountedValue)
      }

      return [...acc, {
        quantity: 1,
        id: +el.value,
        properties: props
      }]
    }, []);

    if (items.length === 0) {
      this.error({
        description: 'Error adding bundle. Please contact support.'
      })
      return;
    }

    // Remove duplicates
    const uniqueItems = items.filter((item, index, array) => {
      const firstInstanceIndex = array.findIndex(a => a.id === item.id);
      if (index !== firstInstanceIndex) {
        array[firstInstanceIndex].quantity += 1
      }
      return index === firstInstanceIndex
    });

    this.addToCart(uniqueItems);
  }

  async addToCart(items) {
    this.submitBtn.classList.add('btn--loading');

    try {
      const res = await fetch('/cart/add.js', {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: items
        })
      });
      const data = await res.json();

      if (res.ok) {
        this.success(data);
      }
    }
    catch (error) {
      console.log(error);
      this.error(error);
    }
    finally {
      this.submitBtn.classList.remove('btn--loading');
    }
  }

  success(data) {
    const errors = this.form.querySelector('.errors');
    if (errors) {
      errors.remove();
    }

    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: {
        product: data
      }
    }));
  }

  error(error) {
    if (!error.description) {
      console.warn(error);
      return;
    }

    const errors = this.form.querySelector('.errors');
    if (errors) {
      errors.remove();
    }

    const errorDiv = document.createElement('div');
    errorDiv.classList.add('errors', 'text-center');
    errorDiv.textContent = error.description;
    this.form.append(errorDiv);

    document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
      detail: {
        errorMessage: error.description
      }
    }));
  }
}

customElements.define('bundle-template', BundleTemplate);
